import React, { useState } from "react";
import "./CardText.css";

export default function CardToggle(props) {
  const [toggled, setToggled] = useState(false);

  if (!props.toggleTitle) {
    // check this
    return null;
  }

  // const to = props.text;
  const toggleParagraphs = props.toggleContent.split("\r\n\r\n");

  const processToggleParagraph = (par) => {
    const splitForTag = par.split("<q>");
    return splitForTag.length > 1 ? splitForTag[1] : splitForTag[0];
  };

  return (
    <p className="card-text">
      <span className="card-toggle" onClick={() => setToggled(!toggled)}>
        {" "}
        <i className={toggled ? "arrow down" : "arrow right"}></i>
        {toggled ? "hide" : "  " + props.toggleTitle}
      </span>
      
      {toggled ? (
        <span>
          <br />
          <br />
          {toggleParagraphs.map((p, i) => (
            <span>
              <span className="card-text-quote">
                {processToggleParagraph(toggleParagraphs[i])}
              </span>
              <br />
              {/* <br /> */}
            </span>
          ))}
        </span>
      ) : null}
    </p>
  );
}
